import { Link } from 'react-router-dom';
import { APP_NAME } from '../config/appConfig';
import './Footer.scss';

export const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="site-footer" id="contact">
      <div className="footer-container">

        <div className="footer-col footer-brand">
          <Link to="/" className="footer-brand__link" aria-label={`${APP_NAME} home`}>
            <img src="/images/logo.png" alt="" aria-hidden="true" />
            <strong>{APP_NAME}</strong>
          </Link>
        </div>

        <div className="footer-col">
          <h3 className="footer-heading">Quick Links</h3>
          <ul className="footer-links">
            <li><Link to="/">Home</Link></li>
            <li><Link to="/search">Explore Hotels</Link></li>
            <li><Link to="/#how-it-works">How it Works</Link></li>
            <li><Link to="/become-a-partner">Become a Partner</Link></li>
            <li><Link to="/contact">Contact Us</Link></li>
          </ul>
        </div>

        <div className="footer-col">
          <h3 className="footer-heading">For Guests</h3>
          <ul className="footer-links">
            <li><Link to="/login">Guest Login</Link></li>
            <li><Link to="/me/enquiries">Track Booking</Link></li>
            <li><Link to="/contact">User Support</Link></li>
            <li><a href="mailto:notification@yet2book.com?subject=Yet2Book%20FAQ">FAQ</a></li>
          </ul>
        </div>

        <div className="footer-col">
          <h3 className="footer-heading">For Partners</h3>
          <ul className="footer-links">
            <li><Link to="/partner/login">Partner Login</Link></li>
            <li><Link to="/become-a-partner">Join as Partner</Link></li>
            <li><Link to="/contact">Partner Support</Link></li>
          </ul>
        </div>

        <div className="footer-col footer-contact">
          <h3 className="footer-heading">Contact Us</h3>
          <p>Email: <a href="mailto:notification@yet2book.com">notification@yet2book.com</a></p>
          <p>Location: UAE-based</p>
        </div>
      </div>

      <img className="footer-skyline" src="/images/image.png" alt="" aria-hidden="true" />

      <div className="footer-bottom">
        <p>© {currentYear} Yet2Book. All rights reserved.</p>
        <div className="footer-social" aria-label="Social media links">
          <img src="/images/footer-social-icons.png" alt="" aria-hidden="true" />
          <a className="footer-social__facebook" href="https://facebook.com" target="_blank" rel="noopener noreferrer" aria-label="Facebook" />
          <a className="footer-social__instagram" href="https://instagram.com" target="_blank" rel="noopener noreferrer" aria-label="Instagram" />
          <a className="footer-social__youtube" href="https://youtube.com" target="_blank" rel="noopener noreferrer" aria-label="YouTube" />
        </div>
      </div>
    </footer>
  );
};
